/** biome-ignore-all lint/a11y/noAutofocus: we want to be able to control autofocus programmatically */

import cx from 'classnames';
import {InputWrapper} from './InputWrapper';

export const InputText = ({
  'aria-label': ariaLabel,
  'data-qa-id': qaId,
  'data-qa-value': qaValue,
  variant = null,
  live = false,
  pristine = false,
  disabled,
  popOverComponent,
  tooltipContent,
  tooltipComponent,
  label,
  required,
  className,
  id,
  showOptionalLabel,
  overlayClassName,
  startAdornment,
  endAdornment,
  error,
  value,
  success,
  translucent,
  onChange,
  onFocus,
  onBlur,
  onKeyPress,
  onKeyDown,
  onInput,
  onPaste,
  placeholder,
  inputClassName,
  maxLength,
  autoComplete,
  pattern,
  autoFocus,
  readonly,
  style,
  tabIndex,
  name,
  type = 'text',
  ref,
}) => {
  return (
    <InputWrapper
      data-qa-id={qaId}
      {...{
        live,
        pristine,
        popOverComponent,
        tooltipContent,
        tooltipComponent,
        label,
        required,
        className,
        id,
        showOptionalLabel,
        overlayClassName,
        startAdornment,
        endAdornment,
        error,
        value,
        success,
        translucent,
        type,
      }}
    >
      <input
        className={cx('input-text', {
          filled: value,
          error: error,
          'with-end-adornment': endAdornment,
          'with-start-adornment': startAdornment,
          translucent: translucent,
          [inputClassName]: !!inputClassName,
          live,
          [variant]: !!variant,
        })}
        id={id}
        data-qa-id={qaId}
        data-qa-value={qaValue}
        value={value}
        onChange={onChange}
        style={style}
        onFocus={onFocus}
        onBlur={onBlur}
        onInput={onInput}
        type={type}
        name={name}
        placeholder={placeholder}
        ref={ref}
        disabled={!!disabled}
        maxLength={maxLength}
        autoComplete={autoComplete}
        pattern={pattern}
        autoFocus={autoFocus}
        onKeyPress={onKeyPress}
        onKeyDown={onKeyDown}
        onPaste={onPaste}
        readOnly={readonly}
        aria-label={ariaLabel}
        tabIndex={tabIndex}
      />
    </InputWrapper>
  );
};
